import {
  requestCountryList,
  resultCheck,
} from '@/api/country';

const state = {
  countryList: null,
  countryCheckResult: null,
};

const getters = {
  countryList: (state) => state.countryList,
  countryCheckResult: (state) => state.countryCheckResult,
};

const actions = {
  async setCountryList({ commit, dispatch }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestCountryList();
    commit('setCountryList', result);
    await dispatch('setIsLoading', false, { root: true });
  },
  async setCountryCheckResult({ commit, dispatch }) {
    await dispatch('setIsLoading', true, { root: true });
    commit('setCountryCheckResult', null);
    const result = await resultCheck();
    commit('setCountryCheckResult', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
};

const mutations = {
  setCountryList(state, countryList) {
    state.countryList = countryList.data.list;
  },
  setCountryCheckResult(state, countryCheckResult) {
    state.countryCheckResult = countryCheckResult;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
